module.exports = __webpack_public_path__ + "img/U.744bb7bc.jpg";